import { render, staticRenderFns } from "./TheDetail.vue?vue&type=template&id=c675085e&scoped=true"
import script from "./TheDetail.vue?vue&type=script&lang=js"
export * from "./TheDetail.vue?vue&type=script&lang=js"
import style0 from "./TheDetail.vue?vue&type=style&index=0&id=c675085e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c675085e",
  null
  
)

export default component.exports